import { ChangeEvent, FC, ReactNode } from "react";

import useA11y from "apps/website/hooks/useA11y";

export interface IBaseCheckboxProps {
  name: string;
  value: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  children?: ReactNode;
  wrapperClassName?: string
  component?: string;
}

export const BaseCheckbox: FC<IBaseCheckboxProps> = ({
  name,
  value,
  checked = false,
  disabled = false,
  onChange,
  children,
  wrapperClassName,
  component,
}) => {
  const { UUID } = useA11y();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e);
    }
  };

  return (
    <div data-component={component ?? BaseCheckbox.name}>
      <label htmlFor={UUID} className={`cursor-pointer ${wrapperClassName}`}>
        <input
          type="checkbox"
          id={UUID}
          name={name}
          value={value}
          onChange={handleChange}
          checked={checked}
          className="absolute w-6 h-6 sr-only cursor-pointer peer"
          tabIndex={0}
          disabled={disabled}
        />
        { children }
      </label>
    </div>
  );
};
